import React, { useState, useEffect,useRef,useCallback } from "react";
import List from "../../../../styledComponents/Table/List";
import menuIcon from "../../../../../assets/images/DeathModuleNew/Menu.png";
import plaidIcon from "../../../../../assets/images/budget/plaidlogo.png";
import { Icon } from "antd";
import moment from "moment";
import Tab, { TabItem } from "../../Recurring/RecurringTabs/Tabs";
import { Table } from "antd";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { MODULE_API } from "../../../../../apis";
import { debounce } from "lodash";
import BUDGET_API from "../../../../../apis/budget.api";
import swal from "sweetalert";

export const CreditCard = (props) => {
  const [dropdown, setDropdown] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState();

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [assetsData, setAssetsData] = useState([]); // Store fetched data
  const fetchedCmIds = useRef(new Set()); // Track already fetched cmIds

  const onTabSelected = (index) => {
    const selectedTabName = getTabNameByIndex(index);
    setSelectedTab(selectedTabName);
    setSelectedIndex(index);
  };
     // Debounced function for API call
     const handleSearch = useCallback(
      debounce(async (query) => {
        console.log("Search Query before filtering Transaction:", query);
    
        if (!query) {
          // await getTransactions();
          // setUpdateState((prev) => !prev);
          return;
        }
    
        setLoading(true);
        try {
          let queryParam = `search=${query}&page=1`;
          if(selectedTab){
            const accountName = selectedTab.includes("_") ? selectedTab.split("_")[0] : selectedTab;
            queryParam += `&accountName=${accountName}`;
          }
          console.log("Query Params: ", queryParam,selectedTab,selectedIndex);
          let initialResponse = await BUDGET_API.fetchFilterTransaction(queryParam);
    
          if (!initialResponse || initialResponse.status !== 200 || !initialResponse.data) {
            swal("Error", "Failed to fetch data", "error");
            return;
          }
    
          const totalPages = initialResponse.data.totalPages;
          let allTransactions = initialResponse.data.transactions || [];
    
          // Prepare API requests for remaining pages
          const pageRequests = [];
          for (let page = 2; page <= totalPages; page++) {
            let paginatedQueryParam = `search=${query}&page=${page}`;
            if (selectedTab) {
              const accountName = selectedTab.includes("_") ? selectedTab.split("_")[0] : selectedTab;
              paginatedQueryParam += `&accountName=${accountName}`;
             }
            pageRequests.push(BUDGET_API.fetchFilterTransaction(paginatedQueryParam));
          }
    
          try {
            // Fetch all pages in parallel
            const responses = await Promise.all(pageRequests);
    
            // Combine results
            responses.forEach((response) => {
              if (response && response.status === 200 && response.data.transactions) {
                allTransactions = allTransactions.concat(response.data.transactions);
              }
            });
    
            // Process data into categories
            const allAccount = allTransactions;
            setSelectedData(allAccount);
          } catch (error) {
            console.error("Error fetching all pages:", error);
            swal("Error", "Failed to fetch search transactions", "error");
          }
        } catch (error) {
          console.log(error);
        }
        setLoading(false);
      }, 500), // Debounce: 500ms delay
      [selectedTab]
    );

  const updateBanksData = (banksData) => {
    const new_banksData = [];
    const tabNameToCmId = {};

    if (banksData) {
      for (const data of banksData) {
        if (data.accountName) {
          const tabName = `${data.accountName}_${data.bankName}${data.accountNumber}`;

          // Push updated data into new_banksData
          const updatedData = { ...data, tabName };
          new_banksData.push(updatedData);

          // Store the latest available cmId for this tabName
          if (data.cmId) {
            tabNameToCmId[tabName] = data.cmId;
          }
        } else {
          new_banksData.push(data);
        }
      }

      return { new_banksData, tabNameToCmId };
    }
  };

  const { new_banksData: updatedBanksData, tabNameToCmId } = updateBanksData(
    props.filterData
      ? props.filterData
      : props.transactions && props.transactions.creditData
      ? props.transactions.creditData
      : []
  );
  const filteredTabs = [
    "All",
    ...new Set(
      updatedBanksData && updatedBanksData.map((item) => item.tabName)
    ),
  ];
  const totalAmount =
    props.banksData &&
    props.banksData.reduce((total, item) => {
      const balance = parseFloat(item.balance);
      if (isNaN(balance)) return total;
      // Create the concatenated account and bank name
      const accountBankCombo =
        item.accountName + "_" + item.bankName + item.accountNumber;
      if (selectedTab === "All") {
        if (filteredTabs && filteredTabs.includes(accountBankCombo)) {
          return total + +balance;
        }
      } else if (selectedTab === accountBankCombo) {
        return total + +balance;
      }
      return total;
    }, 0);
  const negativeTotalAmount =
    totalAmount && totalAmount > 0 ? totalAmount : totalAmount;
  const formattedTotalAmount = negativeTotalAmount
    ? negativeTotalAmount
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : "0";
  const getTabNameByIndex = (index) => {
    if (index >= 0 && index < filteredTabs.length) {
      return filteredTabs[index];
    } else {
      return null;
    }
  };

  const filterDataByTab = () => {
    if (updatedBanksData && selectedTab) {
      let data;
      if (selectedTab === "All") {
        data = updatedBanksData;
      } else {
        data = updatedBanksData.filter((item) => item.tabName === selectedTab);
      }
      setSelectedData(data);
    }
  };
  // useEffect(() => {
  //   if (selectedTab && selectedTab !== undefined && selectedTab !== null) {
  //     filterDataByTab();
  //   }
  // }, [selectedTab,props.state]);
  useEffect(() => {
    if (props.filterData && props.searchQuery) {
      if(selectedTab && selectedTab !== "All" && props.searchQuery!==""){
        handleSearch(props.searchQuery);
      }else{
        setSelectedData(props.filterData);
      }
    } else if (selectedTab && selectedTab !== "All") {
      filterDataByTab();
    } else if (props.transactions && props.transactions.creditData) {
      setSelectedData(props.transactions.creditData);
    } else {
      setSelectedData([]);
    }
  }, [selectedTab, props.state, props.filterData, props.transactions]);
  const userRole = localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client";
  const cols = [
    {
      title: "Date",
      dataIndex: "date",
      // sorter: (a, b) => a["date"] > b["date"],
      sorter: (a, b) => (a.date || "").localeCompare(b.date || ""),
      // render: (record) =>
      //   record ? moment.utc(record).format("MM-DD-YYYY") : "N/A",
      render: (fileName, record) => {
        return record.pending ? (
          <div
            style={{
              background: "#09A84D",
              padding: "4px",
              color: "white",
              display: "flex",
              justifyContent: "center",
              borderRadius: "4px",
              fontWeight: "bold",
            }}>
            Pending
          </div>
        ) : record.date ? (
          moment.utc(record.date).format("MM-DD-YYYY")
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Item",
      dataIndex: "itemName",
      // sorter: (a, b) => a["itemName"] > b["itemName"],
      sorter: (a, b) => (a.itemName || "").localeCompare(b.itemName || ""),
      render: (fileName, record) => {
        return record.itemName ? (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <img
              style={{ borderRadius: "50%" }}
              height={34}
              width={34}
              src={record.itemLogo ? record.itemLogo : plaidIcon}></img>
            <div>{record.itemName}</div>
          </div>
        ) : (
          "N/A"
        );
      },
    },

    {
      title: "Category",
      dataIndex: "categoryFromPlaid",
      // sorter: (a, b) => a["categoryFromPlaid"] > b["categoryFromPlaid"],
      sorter: (a, b) =>
        (a.categoryFromPlaid || "").localeCompare(b.categoryFromPlaid || ""),
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.categoryFromPlaid ? (
          <div 
          style={{cursor:"pointer"}}
          onClick={()=>{
            props.handleOpen();
            handleFormDataUpdate(record);
          }}
          >
            <div>{record.categoryFromPlaid}</div>
            {record.subCategory && (
              <span style={{ color: "black" }}>({record.subCategory})</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => {
        const amountA = parseFloat(a.amount);
        const amountB = parseFloat(b.amount);
        // Toggle sorting order directly
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (fileName, record) => (
        <div
          style={{
            width: "100%",
            fontWeight: "bold",
            color:
              record.typeOfTransaction === "Expense" || record.amount < 0
                ? "black"
                : "#00A27B",
          }}>
          {record.amount
            ? !isNaN(record.amount)
              ? `${
                  "$" +
                  (record.typeOfTransaction === "Expense"
                    ? record.amount < 0
                      ? record.amount.toFixed(2) // Keep negative if already negative
                      : (record.amount * -1).toFixed(2) // Otherwise, make negative
                    : record.typeOfTransaction === "Income"
                    ? record.amount > 0
                      ? record.amount.toFixed(2) // Keep positive if already positive
                      : (record.amount * -1).toFixed(2) // Otherwise, make positive
                    : record.amount < 0
                    ? (record.amount).toFixed(2) // If amount is negative and no type, show as positive
                    : record.amount.toFixed(2)
                  ) // Positive to negative
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }`
              : "N/A"
            : "N/A"}
        </div>
      ),
    },
    {
      title: "Bank",
      dataIndex: "bankName",
      // sorter: (a, b) => a["bankName"] > b["bankName"],
      sorter: (a, b) => (a.bankName || "").localeCompare(b.bankName || ""),
      render: (fileName, record) => {
        return record.bankName ? (
          <div>
            <div>{record.accountName ? `${record.accountName}` : ""}</div>
            {record.accountType && (
              <span style={{ color: "black" }}>{record.accountType}</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Rule Applied",
      dataIndex: "ruleId",
      sorter: (a, b) => (a.ruleId || "").localeCompare(b.ruleId || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      sorter: (a, b) => (a.notes || "").localeCompare(b.notes || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <React.Fragment>
            <div style={{ display: "flex" }} key={index}>
              <div
                onClick={() => {
                  if(userRole){
                  setSelectedItemId(record.id);
                  setDropdown(!dropdown);}
                }}
                style={{
                  cursor: "pointer",
                  marginRight: "1rem",
                  padding: "0px 16px",
                  width: "5px",
                }}>
                <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>
              </div>
              {dropdown && selectedItemId === record.id && (
                <React.Fragment>
                  <div
                    onClick={() => {
                      setDropdown(false);
                    }}
                    className=""
                    style={{
                      position: "fixed",
                      width: "100vw",
                      height: "100vh",
                      background: "black",
                      opacity: "0.1",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      zIndex: "999",
                    }}></div>

                  <div class="dropdown" style={{ zIndex: "9999" }}>
                    <ul className="dropdownul">
                      <li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          props.handleHistoryOpen(record.id);
                        }}>
                        History
                      </li>
                      <li
                        className="liHover"
                        style={{opacity :record.ruleId !== null ? "0.3" : "1", cursor: record.ruleId!==null ? "not-allowed" : "pointer", pointerEvents: record.ruleId!==null ? "none" : "",}}
                        onClick={() => {
                          setDropdown(false);
                          props.handleOpen();
                          handleFormDataUpdate(record);
                        }}>
                        Update
                      </li>

                      <li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          props.deleteTransaction(record.id);
                        }}>
                        Delete
                      </li>
                    </ul>
                  </div>
                </React.Fragment>
              )}{" "}
            </div>
          </React.Fragment>
        );
      },
    },
  ];

    const fetchAssetsData = async (cmIds) => {
      try {
        setLoading(true);
  
        const newCmIds = cmIds.filter((cmId) => !fetchedCmIds.current.has(cmId));
        if (newCmIds.length === 0) {
          setLoading(false);
          return; // No new cmIds to fetch, exit early
        }
        const promises = newCmIds.map(async (cmId) => {
          try {
            const res = await MODULE_API.fetchDetails(cmId);
            if (res && res.data) {
              return {
                cmId,
                assetName: res.data["Nickname of Credit"] || res.data["Nickname of Liabilities"] || null,
              };
            }
            return null;
          } catch (error) {
            console.error(`Error fetching data for cmId ${cmId}:`, error);
            return null; // Handle errors without breaking Promise.all
          }
        });
  
        const results = await Promise.all(promises);
        const validResults = results.filter((res) => res !== null);
        validResults.forEach((item) => fetchedCmIds.current.add(item.cmId));
        setAssetsData((prev) => [...prev, ...validResults]);
        console.log("Fetched assets data:", validResults);
      } catch (error) {
        console.error("Error fetching assets data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (tabNameToCmId) {
        const cmIds = Object.values(tabNameToCmId); // Extract cmIds from your mapping
        if (cmIds.length > 0) {
          fetchAssetsData(cmIds);
        }
      }
    }, [tabNameToCmId]);
  

  const handleFormDataUpdate = (data) => {
    props.handleUpdateFormData(data);
  };
  return (
    <div>
      {filteredTabs && filteredTabs.length > 0 && (
        <div className="TabSection">
          <Tab onTabSelected={onTabSelected} selectedIndex={selectedIndex}>
            {filteredTabs.map((tab, index) => {
              const accountName = tab && tab.includes("_") ? tab.split("_")[0] : tab;
              const cmId = tabNameToCmId && tabNameToCmId[tab] && tabNameToCmId[tab];
              const assetData = assetsData.find((item) => item.cmId === cmId);
              const assetName = assetData && assetData.assetName && assetData.assetName;

              return <TabItem key={index}>{assetName || accountName}</TabItem>;
            })}
          </Tab>
        </div>
      )}
      <div className="subheading">
        Credit Card{" "}
        <span className="subheading_amount">
          ($ {formattedTotalAmount ? `${formattedTotalAmount}` : "0"})
        </span>
      </div>
      <div className="tableContainer">
        <Table
          rowKey="id"
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: props.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
              console.log("selectedRowKeys:", selectedRowKeys);
              console.log("selectedRows:", selectedRows);
              props.selectedRowsDataKeys(selectedRowKeys);
            },
          }}
          pagination={{
            showSizeChanger: true, // Show the page size changer
            pageSizeOptions: ["10", "20", "50", "100"], // Options for page size
            defaultPageSize: 10, // Default page size
          }}
          columns={cols}
          dataSource={
            selectedData && selectedData
              ? selectedData
              : props.transactions
              ? props.transactions.creditData
              : []
          }
        />
        {/*   <List
          cols={cols}
          rows={
            selectedData && selectedData.length > 0
              ? selectedData
              : props.transactions
              ? props.transactions.creditData
              : []
          }
          // rows={props.transactions && props.transactions.creditData}
        /> */}
      </div>
      <NewLoader isLoading={loading}/>
    </div>
  );
};
